// Which account the Lookup activity table asks for, or `null` when it must not ask at all.
//
// A merchant's own dashboard may be read without a business account: the onboarding-demo
// merchant has none yet, and the server answers that case itself from the shared demo rows
// (chargeback_back consumer_clarity/views/dashboard.py, CHA1-2405). Sending no
// `business_account_id` is the right call there — the server resolves the session, and a
// blank id would only be ignored. Blocking the request instead is what left the KPI cards
// full and the table empty.
//
// Support's merchant view is the opposite case. Its target account comes from the URL, and
// without one the server would fall back to the admin's own session — which is nothing,
// or worse, the shared demo rows shown as if they were a merchant's. So there the request
// still waits for an explicit account.
export const lookupRequestScope = ({ businessId, usersViewForAdmin }) => {
  if (usersViewForAdmin) {
    return businessId ? { business_account_id: businessId } : null
  }

  return businessId ? { business_account_id: businessId } : {}
}
